<template>
    <ComponentForm @save="save" :label="trads.createHead" :loading="saving"></ComponentForm>
</template>
<script>
import ComponentForm from "./component-form";
import componentService, { COMPONENT_NAME } from "@/services/component";
import { TrySaveMixin } from "@/mixins/TryLoadMixin";

export default {
    name: "CreateComponent",
    mixins: [TrySaveMixin],
    components: { ComponentForm },
    computed: {
        trads() {
            return this.$trad.admin.componentForm;
        }
    },
    methods: {
        async save(data) {
            const { id } = await this.trySave(() => componentService.create(data));

            const shouldRedirecToCreatedComponent = await this.showSuccessModal()
                // cancels throws, so we convert errors into something usable
                .then(() => true, () => false);

            if (shouldRedirecToCreatedComponent) {
                this.$router.push(`/${COMPONENT_NAME[data.componentType]}/${id}`);
            }
        },
        async showSuccessModal() {
            await this.$swal({
                text: this.$t("modalComponentCreate.successCreateTxt"),
                type: "success",
                confirmButtonText: this.$t("modalComponentCreate.seeNewCancelBtnText"),
                confirmButtonColor: "#41b4e8",
                closeOnConfirm: true,
                closeOnCancel: true,
                showCancelButton: true,
                cancelButtonText: this.$t("modalComponentCreate.seeNewConfirmBtnText")
            });
        }
    }
};
</script>
<style lang="scss">
#main #component-form {
    width: 767px;
    margin: 40px auto;

    @media (max-width: 767px) {
        width: calc(100% - 60px);
    }

    > header {
        margin-bottom: 30px;
        h2 {
            margin: 10px 0;
        }
    }

    > section {
        margin-top: 30px;
    }

    ul {
        margin: 0;
        padding: 0;
        > li {
            list-style-type: none;
        }
    }

    section {
        display: grid;
        grid-template-columns: auto 1fr;
        margin-bottom: 30px;
        grid-column-gap: 20px;
        grid-row-gap: 15px;

        @media (min-width: 767px) {
            align-items: start;
            justify-items: start;
        }

        @media (max-width: 767px) {
            grid-row-gap: 4px;
            grid-template-columns: 1fr;

            > :not(label) {
                margin: 0 15px;
            }
            label {
                &:not(:first-of-type) {
                    margin-top: 15px;
                }
            }
        }
    }

    label {
        text-transform: uppercase;
        font-weight: bold;

        &[required]::after {
            content: " *";
            color: red;
        }
    }

    > .error {
        color: red;
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// create-component.vue?33c011a2